<template>
<div class="driverapplication">
  <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
    <div class="wrap">
      <div class="main">
        <main class="main__content">
          <div class="step__sections" v-if="!submmited">
            <div class="section section--shipping-address ">
              <div class="addAddress" v-if="$i18n.locale === 'en'">
                <div class="section__header__driverapplication">
                  <h2 class="section__title">{{ $t('myumyuDriverTitle')}}</h2>
                </div>
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="showDescription?'':'bg_none'" @click="showDescription = !showDescription">
                    <i :class="showDescription?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('description') }}</span>
                  </div>
                  <div class="fieldset_description" v-show="showDescription">
                     <div class='description'>
                      <h1 class="sub-header">Why Parter With Myumyu?</h1>
                      <p>1. We provide 1099 form.</p>
                      <p>2. We pay you $4 per order.</p>
                      <p>3. We do weekly pay.</p>
                      <h1 class="sub-header">What you'll need to get started:</h1>
                      <p>1. Gotta be 21 years old!</p>
                      <p>2. Valid U.S. driver's license.</p>
                      <p>3. Vehicle insurance & registration.</p>
                      <p>4. Smartphone.</p>
                      <h1 class="sub-header">How it works:</h1>
                      <p>1. Delivery scope will be Rodeo, Hercules, Pinole, Tara Hills, El Sobrante, San Pablo, NorthRichmond, Richmond, El Cerrito, Kensington, Albany, Oakland, Berkeley.</p>
                      <p>2. Login to the Onfleet app from your local facility.</p>
                      <p>3. Grab a few orders.</p>
                      <p>4. Deliver to happy customers.</p>
                      <h1 class="sub-header">No previous delivery experience required! Apply today!</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div class="addAddress" v-if="$i18n.locale === 'ch'">
                <div class="section__header__driverapplication">
                  <h2 class="section__title">{{ $t('myumyuDriverTitle')}}</h2>
                </div>
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="showDescription?'':'bg_none'" @click="showDescription = !showDescription">
                    <i :class="showDescription?'el-icon-minus':'el-icon-plus'"></i><span>描述:</span>
                  </div>
                  <div class="fieldset_description" v-show="showDescription">
                     <div class='description'>
                      <h1 class="sub-header">送货时间(周⼀⾄周五):</h1>
                      <p>2-4pm, 4-6pm, 6-8pm (周末暂时不开放送货业务).</p>
                      <h1 class="sub-header">⼯作地点:</h1>
                      <p>UC Berkeley/ Rodeo / Hercules. Pinole. Tara Hills El Sobrante. San Pablo/ North Richmond. Richmond/ El Cerrito . Kensinton. Albany/ Oakland。集中 以学⽣居住公寓⼂丶宿舍、Single House 等.</p>
                      <h1 class="sub-header">⼯作内容:</h1>
                      <p>下午1:30pm/ 3:30pm /5:30pm在公司(50 West Ohio Ave. Richmond CA. 94804)提取当日时间段需要送达的货品.公司工作人员提前将安排好的线路以及送货信息发送至司机手机APP. 司机根据信息按照APP GPS 中指引依次送货. 司机需要提前使用⼿机APP信息告知包裹预计抵达时间; 抵达地址后在APP上电话通知客人下楼提货. 货品需要学生楼下当面签收. 因为学生居住地址集中的特殊性，会出现多个order同在⼀个⼤楼或者临近地址的情况.</p>
                      <h1 class="sub-header">职责范围:</h1>
                      <p>司机需要使用⾃⼰的车辆进行运送⼯作. 司机本⼈人需要承担: 驾驶汽车的汽油和保险等费用(申请该工作时, 司机必须出具合法的保险证明). 公司不为送货过程中发生的交通意外承担责任.</p>
                      <h1 class="sub-header">工作要求:</h1>
                      <p>认真负责，驾驶记录良好。有服务意识，善于沟通，与公司以及客户交接包裹时，态度和善.</p>
                      <h1 class="sub-header">工资⽀付:</h1>
                      <p>每周五进行上⼀周工资结算，以1099⽀票形式发放. $4/单 除了伯克利之外，如遇到单趟需要跨城市圈送货, 则公司另外支付$10/City</p>
                      <h1 class="sub-header">例如:</h1>
                      <p>2P -4P 10单 伯克利利Berkeley 2单 Albany，则司机将获得送货费: $4x10单+$4x2单+$10=$58</p>
                      <h1 class="sub-header">PS:</h1>
                      <p>根据⽬前经验，送货单量基本10-20单/2个⼩小时。 考虑到工作方便的因素，以居住在Richmond、Albany 、 El Cerrito、Berkeley 之间的应征者为佳! 有意向者请直接添加“MyuMyu店⼩二”微信号:  <strong>JTOWN2018</strong>  添加时请注明:送货司机应聘. 您也可以在https://myumyustore.com/(双语⽹网站)进行Chat(聊天)在线咨询<br />MyuMyu 是一个发展迅速且充满活力的团队，期待您的加盟!</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class='linebreak' />
              <div class="addAddress">
                <div class="section__header__driverapplication">
                  <h2 class="section__title">{{ $t('driverApplication') }}</h2>
                  <div v-if="errorSubmitting" class="time_tip"><span>{{ $t('correctErrors') }}</span></div>
                </div>
                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                  <div class="title" :class="isAddAddress?'':'bg_none'" @click="isAddAddress = !isAddAddress">
                    <i :class="isAddAddress?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('application') }}</span>
                  </div>
                  <div class="fieldset" v-show="isAddAddress">
                    <div class="field">
                      <div class="two">
                        <div class="width">
                          <el-form-item v-bind:label="$t('firstName')" prop="first_name">
                            <el-input v-bind:placeholder="$t('firstName')" v-model="sizeForm.first_name"></el-input>
                          </el-form-item>
                        </div>
                        <div class="width">
                          <el-form-item v-bind:label="$t('lastName')" prop="last_name">
                            <el-input v-bind:placeholder="$t('lastName')" v-model="sizeForm.last_name"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="two">
                        <div class="width">
                          <el-form-item v-bind:label="$t('email')" prop="email">
                            <el-input v-bind:placeholder="$t('email')" v-model="sizeForm.email"></el-input>
                          </el-form-item>
                        </div>
                        <div class="width">
                          <el-form-item v-bind:label="$t('phone')" prop="phone_number">
                            <el-input v-bind:placeholder="$t('phone')" v-model="sizeForm.phone_number"></el-input>

                          </el-form-item>
                        </div>
                      </div>

                      <!-- <div class="two">
                        <div class="width">
                          <el-form-item label="Country" prop="country">
                            <el-input placeholder="Country/Region" v-model="sizeForm.country"></el-input>
                          </el-form-item>
                        </div>
                        <div class="width">
                          <el-form-item label="city" prop="city">
                            <el-input placeholder="City" v-model="sizeForm.city"></el-input>
                          </el-form-item>
                        </div>
                      </div> -->
                      <button class="place btn" @click="onSubmit(sizeForm, $event)">{{ $t('submit') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div v-else class="driverApplicationSuccess">
              <div class="img-container">
                <img :src="myumyuImg" class="headerImg" />
              </div>
            <div class="content-container">
              <p>Thank you for your interest! Your application has been received and is being reviewed. We will contact you as soon as possible</p>
              <p>We are always excited to have the opportunity to meet new people who are interested in working at Myumyu and we are grateful that you are taking the time to consider us.</p>
            </div>
          </div>
        </main>

      </div>
    </div>
  </el-form>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { Alert } from "element-ui";
import logo from "../assets/img/logo.png";
export default {
      metaInfo: {
      title: 'MyuMyu Drivers Needed',
      meta: [
        { name: 'description', content: 'Become a delivery driver for MyuMyu. Simple to sign up with no special licensing required. Use our Onfleet app and start earning today.'}
      ]
    },
  name: "driverapplication",
  data() {
    return {
      //表单默认数据
      sizeForm: {
        first_name: "", //名字
        last_name: "", //名字
        phone_number: "",
        email: "",
        city: "", //城市
        country: "United States" //国家/地区
      },
      //下拉框默认数据
      isAddAddress: true,
      showDescription: true,
      errorSubmitting: false,
      success: false,
      submmited: false,
      myumyuImg: logo
    };
  },
  computed: {
    rules() {
      return {
        first_name: [
          {
            required: true,
            message: this.$t("firstNameRequired"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: this.$t("firstNameLengthRequired"),
            trigger: "blur"
          }
        ],
        last_name: [
          {
            required: true,
            message: this.$t("lastNameRequired"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: this.$t("lastNameLengthRequired"),
            trigger: "blur"
          }
        ],
        city: [
          {
            required: true,
            message: this.$t("cityRequired"),
            trigger: "blur"
          }
          // { min: 3, max: 20, message: 'city length at least 3', trigger: 'blur' }
        ],
        phone_number: [
          {
            required: true,
            message: this.$t("phoneNumberRequired"),
            trigger: "blur"
          },
          {
            min: 10,
            max: 12,
            message: this.$t("phoneNumberLengthRequired"),
            trigger: "blur"
          }
        ],
        country: [
          {
            required: true,
            message: this.$t("countryRequired"),
            trigger: "blur"
          }
          // { min: 3, max: 20, message: 'Country length at least 3', trigger: 'blur' }
        ],
        email: [
          {
            required: true,
            message: this.$t("emailRequired"),
            trigger: "blur"
          },
          {
            message: this.$t("emailValidRequired"),
            trigger: "blur",
            type: "email"
          }
        ]
      };
    }
  },
  methods: {
    ...mapActions("driverApplication", ["apply"]),
    onSubmit(sizeForm, event) {
      event.preventDefault();
      this.errorSubmitting = false;
      this.$refs["sizeForm"].validate(valid => {
        if (!valid) {
          this.errorSubmitting = true;
          return;
        } else {
          this.apply(this.sizeForm)
            .then(res => {
              // async
              // Object.assign(this.$data, this.$options.data.apply(this));
              (this.sizeForm = {
                first_name: "", //名字
                last_name: "", //名字
                phone_number: "",
                email: "",
                city: "", //城市
                country: "United States" //国家/地区
              }),
                this.$refs["sizeForm"].clearValidate();
              this.openAlert();
            })
            .catch(err => {
              alert(err);
            });
        }
      });
    },
    openAlert() {
      this.submmited = true;
      // this.$alert("You have submitted an application", "Success", {
      //   confirmButtonText: "OK",
      //   type: "success",
      //   center: true
      // })
      //   .then(() => {
      //     this.$message({
      //       type: "success",
      //       message: "Delete completed"
      //     });
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "Delete canceled"
      //     });
      //   });
    }
  },
  deactivated( ) {
    this.submmited = false;
  }
};
</script>

<style lang="less">
@import "../assets/css/driverapplication.less";
</style>



// WEBPACK FOOTER //
// src/view/driverApplication.vue